export default "/images/logo-inverse.svg?73b605a4425ad549ac1807683d9449e1";